<template lang="pug">
    div.clipping
        div.add-img-btn(
            @click="addImg"
            :style="[image, { width: `${imgWidth}px`, height: `${imgHeight}px`, }]"
        )
            div.cover-photo-block(
                v-if="cover_photo"
            )
            template(v-else)
                svg-icon.ad-upload-img(icon-class="ad-upload-img")
                span.add-img-btn-tips 上传图片
            input(
                ref="imgInput"
                style="display: none"
                type="file"
                name="image"
                accept="image/png, image/jpeg"
                @change="setImage"
            )
        el-dialog(
            width="792px"
            custom-class="cropper-dialog"
            :visible.sync="imageDialog"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="true"
            append-to-body
        )
            template
                xyt-cropper(
                    :key="+new Date()"
                    ref='cropper'
                    :src=this.imgSrc
                    :wrapperStyle="wrapperStyle"
                    :minCropBoxWidth="100"
                    :aspectRatio="imgWidth/imgHeight"
                    drag-mode="move"
                    :guides="true"
                    :view-mode=2
                    :auto-crop-area=1
                    :background="true"
                    :rotatable="true"
                )
                div.operate
                    el-button(@click="imageDialog = false") 取消
                    el-button-group
                        el-button(
                            icon="el-icon-remove-outline"
                            @click="operate('relativeZoom', -0.1)"
                        )
                        el-button(
                            icon="el-icon-circle-plus-outline"
                            @click="operate('relativeZoom', 0.1)"
                        )
                    el-button-group
                        el-button(
                            icon="el-icon-refresh-left"
                            @click="operate('rotate', -90)"
                        )
                        el-button(
                            icon="el-icon-refresh-right"
                            @click="operate('rotate', 90)"
                        )
                    el-button(
                        @click="cropImage"
                        type="primary"
                    ) 裁剪完成
</template>

<script>
import oss from '@/utils/oss';
import XytCropper from '@/components/cropper/XytCropper';

export default {
    name: 'Clipping',
    components: {
        XytCropper,
    },
    props: {
        imgWidth: {
            type: Number,
            default: 343,
        },
        imgHeight: {
            type: Number,
            default: 103,
        },
        photo: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            imageDialog: false, // 剪裁弹窗
            imgSrc: '', // 剪裁的图片
            wrapperStyle: {
                width: '100%',
                height: '400px',
            },
            cover_photo: this.photo,
            loading: false,
            fileName: '', // 文件名
        };
    },
    computed: {
        image() {
            return {
                backgroundImage: `url(${this.cover_photo})`,
                backgroundSize: 'cover',
            };
        },
    },
    watch: {
        photo(val) {
            this.cover_photo = val;
        },
    },
    methods: {
        checkFile(file) {
            const isLt20M = file.size / 1024 / 1024 < 2;
            const isImg = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
            if (!isLt20M || !isImg) {
                this.$message({
                    message: '请上传小于2M的JPG、PNG图片',
                    type: 'warning',
                });
            }
            return isLt20M && isImg;
        },
        setImage(e) {
            const file = e.target.files[0];
            if (file.name) this.fileName = file.name;
            if (!this.checkFile(file)) return;
            const reader = new FileReader();
            reader.onload = (event) => {
                const dataBase = event.target.result;
                this.imgSrc = dataBase;
                this.imageDialog = true;
                this.$nextTick(() => {
                    this.$refs.cropper.replace(dataBase);
                });
            };
            reader.readAsDataURL(file);
        },
        addImg() {
            this.clearFile();
            this.$refs.imgInput.click();
        },
        // 清掉input file
        clearFile() {
            this.$refs.imgInput.value = '';
        },
        dataURLtoFile(dataurl) {
            // eslint-disable-next-line
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            // eslint-disable-next-line
                return new File([u8arr], this.fileName, {type:mime});
        },
        async cropImage() {
            this.imageDialog = false;
            this.cover_photo = this.$refs.cropper.getCroppedCanvas().toDataURL();
            const fileData = this.dataURLtoFile(this.cover_photo);
            try {
                const res = await oss.uploadFiles([
                    fileData,
                ], 'shop');
                this.$emit('getImg', res[0].name);
            } catch (e) {
                throw new Error(e);
            } finally {
                this.loading = false;
            }
        },
        operate(type, val) {
            this.$refs.cropper[type](val);
        },
    },
};
</script>

<style lang="scss" scoped>
    .clipping {
        display: flex;
        align-items: center;
        .add-img-btn {
            width: 345px;
            height: 138px;
            border: 1px dashed;
            @include border_color(color_base_gray5);
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &:hover {
                @include border_color(text_color_primary);
            }
            .ad-upload-img {
                width: 40px;
                height: 40px;
            }
            .add-img-btn-tips {
                line-height: 20px;
                @include font_size(text_main_content);
                @include font_color(text_color_gray);
            }
        }

        .cover-photo-block {
            width: inherit;
            height: inherit;
        }
        .cover-photo-block:hover:after{
            position: absolute;
            left: 160px;
            top: 80px;
            display: block;
            width: 108px;
            height: 32px;
            border: 1px #fff solid;
            content: '替换图片';
            @include font_color(text_color_white);
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .cover-photo-block:hover:before{
            position:absolute;
            left: 10px;
            top: 10px;
            display: block;
            width: inherit;
            height: inherit;
            background-color: rgba(0, 0, 0, 0.5);
            content: ' ';
            @include font_color(text_color_white);
            transition: all 1s ease;
        }
    }
</style>

<style lang="scss">
    .clipping {
        .el-dialog__header {
            @include bg_color(color_base_white);
        }
        .el-dialog__body {
            padding: 0 0 20px 0;
        }
    }
    .cropper-dialog {
        .operate {
            display: flex;
            justify-content: space-between;
            width: 70%;
            margin: 0 auto;
            padding: 20px 0 20px;
        }
    }
</style>
